const coin = {
  title: 'Coin',
  thisMonthRecharge: 'This month recharge',
  thisMonthReward: 'This month reward',
};

const bean = {
  title: 'Bean',
};

const gem = {
  title: 'Gem',
};

const pearl = {
  title: 'Pearl',
};

const list = {
  type: 'type: {{type}}',
};

const coffee = {
  title: 'Coffee',
};

const chart = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
};

export default {
  coin,
  bean,
  gem,
  pearl,
  coffee,
  chart,
  list,
  supporters: 'Supporters',
  report: 'Report',
  detail: 'Detail',
  exchange: 'Exchange',
  recharge: 'Recharge',
  yesterdayIncome: "Yesterday's income",
  todayIncome: "Today's income",
  monthIncome: 'This monthly income',
};
